// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-search-container {
  max-width: 80%; /* Takes 75% of the width */
  margin: 0 auto; /* Center the container */
  padding: 20px;
}

.quick-search-col {
  display: flex;
  justify-content: center;
}

.quick-search-button {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 200;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.quick-search-icon {
  margin-right: 8px;
  font-size: 24px; /* Icon size */
}

.quick-search-label {
  font-size: 16px;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/Componenets/QuickSearchComponent.css"],"names":[],"mappings":"AAAA;EACE,cAAc,EAAE,2BAA2B;EAC3C,cAAc,EAAE,yBAAyB;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe,EAAE,cAAc;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".quick-search-container {\n  max-width: 80%; /* Takes 75% of the width */\n  margin: 0 auto; /* Center the container */\n  padding: 20px;\n}\n\n.quick-search-col {\n  display: flex;\n  justify-content: center;\n}\n\n.quick-search-button {\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 200;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.quick-search-icon {\n  margin-right: 8px;\n  font-size: 24px; /* Icon size */\n}\n\n.quick-search-label {\n  font-size: 16px;\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
